import { API_ENDPOINT_STATISTICS } from 'app/endpoints';

export async function track(customData) {
    const data = {
        ...customData,
        params: {
            page_location: window.location.href,
            page_referrer: document.referrer,
            page_title: document.title,
            ...customData.params,
        },
    };

    try {
        await fetch(API_ENDPOINT_STATISTICS, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('[name="_token"]')?.getAttribute('content'),
                'X-Requested-With': 'XMLHttpRequest',
            },
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        if (APP_ENVIRONMENT !== 'production') console.error(error);
    }
}
